import React from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import Home from '../../pages/home/index';
import Landing from '../../pages/landing/index';
import mainLandingSlides from '../../pages/landing/questionare/mainSlides';
import signUpSlides from '../../pages/landing/questionare/slides/signUp';
import signInSlides from '../../pages/landing/questionare/slides/signIn';
import CCMRS from '../../pages/ccmrs/index';
import Sculpture from '../../pages/sculpture';
import CHW from '../../pages/chw';
import PaypalRouter from '../../api/paypal/router';
import AuthRouter from '../../api/auth/router';
import BuyCourse from '../../pages/payment/BuyCourse';
import SupportPage from '../../pages/support';
import ContactMePage from '../../pages/contactMe';
import CoursePage from '../../pages/home/displaySection/index';
import PhotoCreditPage from '../../pages/photoCredit';
import Four04Page from '../../pages/404';
import Terms from '../../pages/terms';
import VideoContent from '../../pages/videoContent';
import DUOCRouter from '../../api/paypal/duocRouter';
import CoursesInfo from '../../pages/payment/courseInformation';

export default function Body() {
	return (
		<Switch>
			<Route path='/Home'>
				<Home />
			</Route>
			<AuthRouter path='/ccmrs/purchase' requiredRole='user'>
				<BuyCourse {...CoursesInfo[0]} />
			</AuthRouter>
			<AuthRouter path='/sculpture/purchase' requiredRole='user'>
				<BuyCourse {...CoursesInfo[1]} />
			</AuthRouter>
			<AuthRouter path='/chw/purchase' requiredRole='user'>
				<BuyCourse {...CoursesInfo[2]} />
			</AuthRouter>
			<AuthRouter path='/unp/purchase' requiredRole='user'>
				<BuyCourse {...CoursesInfo[3]} />
			</AuthRouter>
			<PaypalRouter path='/ccmrs' courseName='ccmrs'>
				<CCMRS />
			</PaypalRouter>
			<PaypalRouter path='/sculpture' courseName='sculpture'>
				<Sculpture />
			</PaypalRouter>
			<PaypalRouter path='/chw' courseName='chw'>
				<CHW />
			</PaypalRouter>
			<Route path='/unp' courseName='unp'>
				<Four04Page />
			</Route>
			<Route path='/signin'>
				<Landing slideTemplate={signInSlides} />
			</Route>
			<Route path='/signup'>
				<Landing slideTemplate={signUpSlides} />
			</Route>
			<Route path='/support'>
				<SupportPage mt={true} />
			</Route>
			<Route path='/contact'>
				<ContactMePage />
			</Route>
			<Route path='/courses'>
				<CoursePage />
			</Route>
			<Route path='/photocredit'>
				<PhotoCreditPage />
			</Route>
			<Route exact path='/'>
				<Landing slideTemplate={mainLandingSlides} />
			</Route>
			<Route path='/terms'>
				<Terms />
			</Route>
			{/* <DUOCRouter path='/videocontent'> */}
			<Route path='/videocontent'>
				<VideoContent />
			</Route>

			{/* </DUOCRouter> */}
			<Route>
				<Four04Page />
			</Route>
		</Switch>
	);
}
